import type { AnimationProps } from '@allesauto/core/animation';
import dynamic from 'next/dynamic';

// workaround import path due to webpack bug https://github.com/webpack/webpack/issues/13865
export const DynamicAnimation = dynamic<AnimationProps>(
  () => import('../../../../../packages/allesauto-core/src/lib/animation')
);
